import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route changes, except when navigation was triggered by a language switch
// or when a target section scroll is requested via state.scrollTo.
export default function ScrollToTop() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    // Language switch: never scroll.
    if (location.state && location.state.languageSwitch) {
      lastPath.current = location.pathname;
      return;
    }
    // Section-scroll navigation: Home component handles the scroll itself.
    if (location.state && location.state.scrollTo) {
      lastPath.current = location.pathname;
      return;
    }
    // Only scroll to top when the pathname actually changed. Prevents resetting when
    // Home clears its own `scrollTo` state after scrolling.
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    window.scrollTo(0, 0);
  }, [location.pathname, location.state]);

  return null;
}
